app.OrgDetailsView = app.BaseDetailsView.extend({
  initialize() {
    app.BaseDetailsView.prototype.initialize.apply(this, arguments);

    // Listen for the locations to be loaded so we can render the location dropdowns in web settings
    this.listenTo(app.locationList, 'reset', (/* e */) => {
      if (this.$el.html().length) {
        this.render();
      }
    });

    if (app.sessionUser.isBite() || app.org.get('enterpriseTagId')) {
      this.listenTo(app.enterpriseTagList, 'reset', (/* e */) => {
        if (this.$el.html().length) {
          this.render();
        }
      });
    }
  },

  getSchema() {
    const schema = app.JsonHelper.deepClone(app.BaseDetailsView.prototype.getSchema.apply(this));

    return schema;
  },

  _getTabId() {
    return Object.values(this.getSchema().fields)[0].tabId;
  },

  _renderCustomTemplates() {
    if (!app.sessionUser.isBite() || this._getTabId() !== 'org-settings') {
      return;
    }

    const $displayGroup = $('<div class="field-group"></div>');
    $displayGroup.append(
      this.valueDisplayTemplate({
        label: 'Org ID:',
        // The org schema has no orgId field because the org doc's own id is the org id.
        value: this.model.id,
      }),
    );
    this.$el.append($displayGroup);
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    this._renderCustomTemplates();

    return this;
  },
});
